<div class="main-container mat-typography mat-body">
  <div class="card-container">
    <div class="member-drug-container">

      <!-- Main Container -->
      <mat-card appearance="outlined" class="find-member-drug-card">

        <!-- Title -->
        <mat-card-title>
          <h2>{{title}} <small>{{subTitle}}</small></h2>
        </mat-card-title>

        <!-- Description -->
        <p>{{description}}</p>

        <form [formGroup]="form">
          <div class="flex-contents">

            <div class="form-fields flex-contents">
              <mat-form-field appearance="outline">
                <mat-label>First Name</mat-label>
                <input type="text" matInput formControlName="firstName" placeholder="First Name" maxlength="25">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastName" placeholder="Last Name" maxlength="25">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Date of Birth</mat-label>
                <input matInput
                  #entryRef
                  maxlength="10"
                  placeholder="01/01/1970"
                  formControlName="dateOfBirth"
                  [matDatepicker]="picker"
                  name="dateOfBirth"/>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker startView='multi-year'></mat-datepicker>
                </mat-form-field>
              </div>

              @if (showDirtyError) {
                <div class="form-error">
                  <mat-error>
                    You must fill out at least one field to search for members.
                  </mat-error>
                </div>
              }

              <div class="member-drug-search">
                @if (showSearchSpinner) {
                  <mat-spinner [diameter]="36"></mat-spinner>
                }
                @if (!showSearchSpinner) {
                  <button mat-raised-button color="primary" class="search-member" (click)="searchMembers()">Search</button>
                }
              </div>
            </div>
          </form>

          <!-- Selected Item -->
          <mat-card-content class="selected-members-container">
            @if (showNoResults) {
              <div class="form-error">
                <mat-error class='no-members-found-msg'>
                  No members found
                </mat-error>
              </div>
            }

            @if (memberResults?.length) {
              <br/>
              <hr/>
              <br/>
              @for (member of memberResults; track member; let index = $index) {
                <div class="member-result">
                  <mat-card appearance="outlined" class="member-card">
                    <mat-card-content>
                      <div class="member-info">
                        <div>{{member.FirstName}} {{member.LastName}}</div>
                        @if (member.Address1) {
                          <div><small>{{member.Address1}}</small></div>
                        }
                        @if (member.Address2) {
                          <div><small>{{member.Address2}}</small></div>
                        }
                        @if (member.State) {
                          <div><small>{{member.State}} &nbsp; {{member.Zip}}</small></div>
                        }
                      </div>
                      <div class="member-action">
                        @if (!showSelectSpinner[index]) {
                          <button
                            mat-raised-button
                            color="primary"
                            class="select-member"
                            [disabled]="!showSelectSpinner[index] && disableOtherSelect"
                          (click)="selectMember(member, index)">Select</button>
                        }
                        @if (showSelectSpinner[index]) {
                          <mat-spinner [diameter]="25"></mat-spinner>
                        }
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
              }
            }
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
